exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fieldset.scheduler-border {\n  border: 1px groove #fffefe !important;\n  padding: 0 1.4em 1.4em 1.4em !important;\n  margin: 0 0 1.5em 0 !important;\n  -webkit-box-shadow: 0px 0px 0px 0px #c2cfd6;\n  box-shadow: 0px 0px 0px 0px #c2cfd6;\n  width: 100%; }\n\nlegend.scheduler-border {\n  font-size: 1em !important;\n  font-weight: bold !important;\n  text-align: left !important;\n  width: auto;\n  padding: 0 10px;\n  border-bottom: none;\n  color: #565656; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/questionnaire-popup/questionnaire-popup.component.scss
// module id = ../../../../../src/app/questionnaire-popup/questionnaire-popup.component.scss
// module chunks = main